import { isValidPhoneNumber } from "libphonenumber-js";
import { IAPIResponse } from "../types/interfaces/IAPIResponse";

export const isValidUsPhoneNumber = (phoneNumber: string): boolean => {
    return isValidPhoneNumber(phoneNumber, "US");
}

// Display-only title case for option labels and brand/model text (LW-1534).
// Per word segment: alphanumeric codes are upper-cased ("5007f" -> "5007F"),
// intentional mixed case is kept ("iPhone", "DeWalt"), and anything else is
// capitalized ("BLACK & decker" -> "Black & Decker"). Render-time only — never
// write the result back into state, so API payloads stay unchanged.
const isMixedCase = (word: string): boolean => /\p{Ll}/u.test(word) && /\p{Lu}/u.test(word.slice(1));

export const toDisplayTitleCase = (value: string): string =>
    value.replace(/[^\s\-/(&]+/g, (word) => {
        if (/\d/.test(word)) return word.toUpperCase();
        if (isMixedCase(word)) return word;
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });

export const resolvePromiseWithError = async (error: any, url: any = null, config: any = null): Promise<IAPIResponse> => {
    return await Promise.resolve({
        data: null, error
    });
}

export const resolvePromiseWithSuccess = async (data: any = null): Promise<IAPIResponse> => {
    return await Promise.resolve({
        data: data, error: null
    });
}

export const getRequestUrlWithParams = (path: string, params: any) => {
    if (!path) return null;

    const baseUrl: any = getGlobalVal('API_BASE_URL');
    if (!baseUrl) return null;

    let dataRequestUrl = `${baseUrl}/${path}`;

    if (params && params instanceof Object) {
        const tmpParams = Object.entries(params)
                            .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val as string)}`)
                            .join('&');
        dataRequestUrl += dataRequestUrl.includes('?') ? '&' : '?' + tmpParams;
    }

    return dataRequestUrl;
}

export const loadScript = (
    id: string,
    src: string,
    parent = document.body,
    async = true 
) => {
    return new Promise<void>((resolve, reject) => {
        if (document.getElementById(id) != null) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.async = async;
        script.setAttribute('id', id);
        script.setAttribute('src', src);
        script.setAttribute('type', 'text/javascript');
        parent.appendChild(script);
        script.onload = () => resolve();
    });
}

export const loadStyle = (
    id: string,
    src: string,
    parent = document.head
) => {
    if (document.getElementById(id) != null) {
        return;
    }

    const style = document.createElement('link');
    style.setAttribute('id', id);
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('type', 'text/css');
    style.setAttribute('href', src);

    parent.appendChild(style);

    return style;
}

export const cleanElementId = (elementId: string) => {
    return elementId.replace(/-/g, '_');
}

export const getGlobalVal = (varName: string) => {
    if (!window.EZ) return null;
  
    let value = null;
    try {
        let jsonData = JSON.parse(atob(window.EZ))
        value = jsonData[varName];
    } catch (error) {
        console.error('Global config values not found.', window.EZ)
    }

    return value;
}

export const CATEGORY_DISPLAY_ORDER = [
    "Video Game Consoles",
    "Laptops",
    "Tablets",
    "Smart Phones",
    "Digital Led TVs",
    "Smart Watches",
    "Portable Speakers",
    "Desktops",
    "Portable Video Game Systems",
    "Headphones",
    "Earbuds",
    "Gaming Controllers",
    "Car Woofer/ Sub-Woofer Speakers",
    "Virtual reality devices"
];


export const getCookieValue = (name: string) => {
  const value = document.cookie
    .split('; ')
    .find(row => row.startsWith(name + '='))
    ?.split('=')[1];

  return value ? decodeURIComponent(value) : null;
}